// apiMap.tsx
// Remove any `http` or other Node-only imports from frontend files.
// import { get } from "http"; // <-- remove this

import { AI_BASE_URL, AI_WS_URL, BASE_URL } from "./constant/config";
export { BASE_URL, AI_BASE_URL, AI_WS_URL };

export const APIMapping = {
  /*************************** Auth API ******************************/
  authLogin: "/api/auth/login",
  authLogout: "/api/auth/logout",
  authRefresh: "/api/auth/refresh",
  authMe: "/api/auth/me",
  /*************************** Project API ******************************/
  createProject: "/api/projects/enhanced",
  editProject: "/api/projects",
  getProjects: "/api/projects/enhanced",
  getProjectById: "/api/projects", //?courseId=courseId
  publishProject: "/api/projects/:id/publish",
  unpublishProject: "/api/projects/:id/unpublish",
  deleteProject: "/api/projects/",
  saveAsTemplate: "/api/projects/enhanced",
  updateTemplate: "/api/projects/templates/:templateId",
  duplicateProjectByID: "/api/projects/",
  createTemplate: "/api/projects/templates",
  convertProjectToTemplate: "/api/projects/:projectId/create-template",
  getTemplates: "/api/projects/templates",
  createProjectFromTemplate: "/api/projects/templates",
  getProjectStats: "/api/projects/projectStats",
  getTemplateCategories: "/api/projects/template-categories",
  getTemplateSubcategories: "/api/projects/template-subcategories",
  getProjectFiles: "/api/projects/:projectId/files",
  getGroupDetails: "/api/projects/:projectId/group-details",
  shareFile: "/api/projects/:projectId/groups/share/file",
  getSharedFile: "/api/projects/:projectId/files/shared",
  /*************************** Course API ******************************/
  getCourses: "/api/courses/project-creation",
  getCourseTeachingStaff: "/api/courses/:courseId/teaching-staff",
  /*************************** Student Dashboard API ******************************/
  getStudentCourses: "/api/student-dashboard/courses",
  syncStudentCourses: "/api/student-dashboard/courses/sync",
  getCourseDetails: "/api/student-dashboard/courses/:contextId/details",
  getCourseAssignments: "/api/student-dashboard/courses/:contextId/assignments",
  getCourseOverview: "/api/student-dashboard/courses/:contextId/overview",
  getModuleDetails:
    "/api/student-dashboard/courses/:contextId/modules/:moduleId",
  getModuleCompletionStatus:
    "/api/student-dashboard/courses/:contextId/modules/:moduleId/complete",
  markModuleComplete:
    "/api/student-dashboard/courses/:contextId/modules/:moduleId/complete",
  getCourseSkills: "/api/student-dashboard/courses/:contextId/skills",
  getAssignmentStatus:
    "/api/student-dashboard/courses/:contextId/assignments/:assignId/status",
  /*************************** Quiz Attempt API ******************************/
  startQuizAttempt: "/api/quiz-attempt/start",
  getQuizAttemptData: "/api/quiz-attempt/:attemptId",
  processQuizAttempt: "/api/quiz-attempt/:attemptId/process",
  getQuizAttemptReview: "/api/quiz-attempt/:attemptId/review",
  getUserAttemptHistory: "/api/quiz-attempt/history",
  /*************************** Dataset API ******************************/
  uploadDataset: "/api/s3/upload-project-dataset",
  uploadEvaluationScript: "/api/projects/:id/evaluation-script",
  generateEvaluationScript: "/api/projects/:id/evaluation-script/generate",
  getEvaluationScriptStatus: "/api/projects/:id/evaluation-script/status",

  /*************************** Checkpoint API ******************************/
  createCheckPoint: "/api/checkpoints",
  bulkUpdateCheckPoints: "/api/checkpoints/bulk-update",
  checkpointAction: "/api/submissions/users/:userId/projects/:projectId",
  /*************************** Rubric API ******************************/
  createRubric: "/api/rubrics",
  updateRubric: "/api/rubrics/bulk-update",
  /*************************** Jupyter Management API ******************************/
  jupyterCreateWorkspace: "/api/jupyter/:projectId/createWorkspace",
  jupyterCancelWorkspace: "/api/jupyter/:projectId/cancel",
  jupyterGetWorkspaceStatus: "/api/jupyter/:projectId/workspaceStatus",
  jupyterGetActiveSession: "/api/jupyter/:projectId/activeSession",
  jupyterLocalRunCommand: "/api/jupyter/:projectId/local-run-command",
  jupyterWorkspaceCreateEnhanced: "/api/jupyter/workspace/create-enhanced",
  jupyterHubStop: "/api/jupyterhub/stop",
  jupyterGetContents: "/api/jupyter/api/contents/:projectId",
  jupyterGetContentsByDirectory:
    "/api/jupyter/api/contents/:projectId/:directory",
  jupyterGetServerVersion: "/api/jupyter/api",
  jupyterGetCurrentUser: "/api/jupyter/api/me",
  jupyterGetServerStatus: "/api/jupyter/api/status",
  jupyterGetSession: "/api/jupyter/api/sessions/:session",
  jupyterListSessions: "/api/jupyter/api/sessions",
  jupyterCreateSession: "/api/jupyter/api/sessions",
  jupyterListKernels: "/api/jupyter/api/kernels",
  jupyterStartKernel: "/api/jupyter/api/kernels",
  jupyterGetKernel: "/api/jupyter/api/kernels/:kernelId",
  jupyterDeleteKernel: "/api/jupyter/api/kernels/:kernelId",
  jupyterInterruptKernel: "/api/jupyter/api/kernels/:kernelId/interrupt",
  jupyterRestartKernel: "/api/jupyter/api/kernels/:kernelId/restart",
  jupyterExecuteCell: "/api/jupyter/kernels/:kernelId/execute",
  jupyterExecuteNotebook: "/api/jupyter/kernels/:kernelId/execute-notebook",
  jupyterCreateContents: "/api/jupyter/api/contents/:path",
  jupyterUpdateContents: "/api/jupyter/api/contents/:path",
  jupyterDeleteContents: "/api/jupyter/api/contents/:path",
  jupyterGetCheckpoints: "/api/jupyter/api/contents/:path/checkpoints",
  jupyterCreateCheckpoint: "/api/jupyter/api/contents/:path/checkpoints",
  jupyterRestoreCheckpoint:
    "/api/jupyter/api/contents/:path/checkpoints/:checkpointId",
  jupyterDeleteCheckpoint:
    "/api/jupyter/api/contents/:path/checkpoints/:checkpointId",
  //Launch review sandbox for a submission
  jupyterLaunchReviewSandbox:
    "/api/submissions/checkpoint-progress/:id/create-review-sandbox",
  /*************************** Direct Workspace Gateway API ******************************/
  workspaceGetContents: "/api/jupyter/api/contents/:projectId",
  workspaceGetContentsByDirectory: "/api/jupyter/api/contents/:projectId/:directory",
  workspaceGetServerVersion: "/api/jupyter/api",
  workspaceGetCurrentUser: "/api/jupyter/api/me",
  workspaceGetServerStatus: "/api/jupyter/api/status",
  workspaceGetSession: "/api/jupyter/api/sessions/:session",
  workspaceListSessions: "/api/jupyter/api/sessions",
  workspaceCreateSession: "/api/jupyter/api/sessions",
  workspaceListKernels: "/api/jupyter/api/kernels",
  workspaceStartKernel: "/api/jupyter/api/kernels",
  workspaceGetKernel: "/api/jupyter/api/kernels/:kernelId",
  workspaceDeleteKernel: "/api/jupyter/api/kernels/:kernelId",
  workspaceInterruptKernel: "/api/jupyter/api/kernels/:kernelId/interrupt",
  workspaceRestartKernel: "/api/jupyter/api/kernels/:kernelId/restart",
  workspaceExecuteCell: "/api/jupyter/kernels/:kernelId/execute",
  workspaceExecuteNotebook: "/api/jupyter/kernels/:kernelId/execute-notebook",
  workspaceCreateContents: "/api/jupyter/api/contents/:path",
  workspaceUpdateContents: "/api/jupyter/api/contents/:path",
  workspaceDeleteContents: "/api/jupyter/api/contents/:path",
  workspaceGetCheckpoints: "/api/jupyter/api/contents/:path/checkpoints",
  workspaceCreateCheckpoint: "/api/jupyter/api/contents/:path/checkpoints",
  workspaceRestoreCheckpoint: "/api/jupyter/api/contents/:path/checkpoints/:checkpointId",
  workspaceDeleteCheckpoint: "/api/jupyter/api/contents/:path/checkpoints/:checkpointId",
  workspaceGetStatus: "/api/jupyter/:projectId/workspaceStatus",
  workspaceSandboxHeartbeat: "/api/jupyter/sandbox/heartbeat",

  /*************************** Submissions ******************************/
  getAllSubmissions: "/api/submissions",
  getSubmissionById: "/api/submissions/:submissionId",
  updateSubmission: "/api/submissions",
  autosaveSubmission: "/api/submissions/autosave",
  submitFinalAssignment: "/api/submissions/:submissionId/submit",
  downloadSubmissionNotebook: "/api/submissions/:submissionId/download",
  getProjectSubmissionStatistics:
    "/api/submissions/project/:projectId/statistics",
  getProjectSubmissions: "/api/submissions/projects/:projectId",
  getProjectSubmissionDetails:
    "/api/submissions/users/:userId/projects/:projectId",
  getRecentSubmissions: "/api/submissions/recent-submissions",
  /*************************** LTI API ******************************/
  ltiGetContexts: "/api/lti/contexts",
  ltiGetContextMembers: "/api/lti/contexts/members",
  ltiGetUnassignedResourceLinks: "/api/lti/resource-links/unassigned",
  ltiLinkProject: "/api/lti/ags/link-project",
  /*************************** Grade API ******************************/
  createGrades: "/api/grades/rubric-based",
  getGrades: "/api/grades/submission/:submissionId/progress-details",
  ltiUploadFile: "/api/jupyter/upload-file",
  getAllGrades: "/api/grades",
  /*************************** Grade API ******************************/
  // instructorDashboard: "/api/instructor/dashboard",
  getStudentsGradebook: "/api/grades/students/gradebook",
  getStudentDetailedGradebook: "/api/grades/students/:user_id/gradebook",
  getGradeContexts: "/api/grade-dropdown/courses",
  getGradeProjects: "/api/grade-dropdown/projects",
  /*************************** Dashboard API ******************************/
  instructorDashboard: "/api/instructor/dashboard",
  adminDashboard: "/api/admin/dashboard",
  // Enhanced Messages API
  enhancedSendOneToOne: "/api/messages/enhanced",
  enhancedCreateGroupAndSend: "/api/messages/enhanced",
  enhancedGetInbox: "/api/messages/enhanced",
  enhancedReplyById: "/api/messages/enhanced/:id/reply",
  enhancedGetThreadById: "/api/messages/enhanced/thread/:threadId",
  enhancedMarkReadSingle: "/api/messages/enhanced/:messageId/read",
  enhancedGetUnreadCount: "/api/messages/enhanced/unread-count",
  enhancedMarkReadBulk: "/api/messages/enhanced/mark-read",
  enhancedGetSent: "/api/messages/enhanced/sent",
  enhancedUpdateById: "/api/messages/enhanced/:messageId",
  enhancedDeleteById: "/api/messages/enhanced/:messageId",
  // Enhanced Announcements API
  getCourseProjects: "/api/courses/projects",
  getUserListByRole: "/api/users/list-by-role",
  createAnnouncement: "/api/announcements/enhanced",
  togglePinStatus: "/api/announcements/enhanced/:id/toggle-pin",
  getAllAnnouncements: "/api/announcements/enhanced",
  markAnnouncementRead: "/api/announcements/enhanced/:id/read",
  //notifications
  getNotifications: "/api/notifications/enhanced",
  notificationsCounts: "/api/notifications/enhanced/count",
  notificationsStream: "/api/notifications/enhanced/stream",
  notificationsMarkAllRead: "/api/notifications/enhanced/mark-all-read",
  /*************************** Jupyter Sandbox Management API ******************************/
  // Sandbox time management
  jupyterSandboxHeartbeat: "/api/jupyter/sandbox/heartbeat",
  jupyterSandboxStop: "/api/jupyter/sandbox/stop",
  jupterSandboxStopById: "/api/jupyter/sandbox/stop-by-id",
  createTimeExtensionRequest: "/api/time-extension",
  getActiveSandboxList: "/api/time-extension/active-sandbox",
  getActiveSandboxDropdown: "/api/time-extension/active-sandbox-dropdown",
  /*************************** User Management API ******************************/
  getUsers: "/api/users",
  getStaffUsers: "/api/users/staff",
  getAdminUsers: "/api/users/admins",
  getStudentUsers: "/api/users/students",
  getUserCounts: "/api/users/counts",
  getUserById: "/api/users/:id",
  deleteUserById: "/api/users/:userId/courses/:courseId",
  /*************************** Group Import APIs ******************************/
  downloadGroupImportTemplate:
    "/api/projects/:projectId/groups/import-template",
  validateGroupImport: "/api/projects/:projectId/groups/validate-import",
  importGroups: "/api/projects/:projectId/groups/import",
  updateGroups: "/api/projects/:projectId/groups/update",
  deleteAllProjectGroups: "/api/projects/:projectId/groups",
  deleteGroupById: "/api/projects/groups/:groupId",
  deleteGroupMember: "/api/projects/groups/:groupId/members/:userId",
  deleteImportedGroups: "/api/projects/:projectId/groups",
  /*************************** Time Extension APIs ******************************/
  getTimeExtensionRequests: "/api/time-extension",
  updateTimeExtensionStatus: "/api/time-extension/:id/status",
  bulkUpdateTimeExtensionStatus: "/api/time-extension/bulk-status",
  /*************************** Fetch all packages ******************************/
  fetchPackages: "/api/packages",
  /*************************** Chat API ******************************/
  createConversation: "/api/chat/conversations",
  sendMessage: "/api/chat/message",
  /*************************** Theme Configuration APIs ******************************/
  themeConfiguration: "/api/settings",
  configuration: "/api/config",
  lmsToolConfiguration: "/api/lti/platforms",
  /*************************** Fishbone API ******************************/
  fishboneApiKey: "/api/admin/fishbone-key",
  fishboneApiKeyRotate: "/api/admin/fishbone-key/rotate",
  /*************************** Resource Profile APIs ******************************/
  createResourceProfile: "/api/resource-profiles",
  getResourceProfiles: "/api/resource-profiles",
  updateResourceProfile: "/api/resource-profiles/:id",
  getResourceProfilesDropdown: "/api/resource-profiles/dropdown/list",

  /*************************** Create Dataset APIs******************************/
  createDataset: "/api/dataset-repo",
  getDatasets: "/api/dataset-repo",
  linkDataset: "/api/dataset-repo/link",
  unlinkDataset: "/api/dataset-repo/unlink",
  getDatasetById: "/api/dataset-repo/:id",
  updateDataset: "/api/dataset-repo/:id",

  /*************************** Project Discussion API ******************************/
  getProjectDiscussion: "/api/projects/:projectId/discussion",
  getProjectDiscussionMessages: "/api/projects/:projectId/discussion/messages",
  sendProjectMessage: "/api/projects/:projectId/discussion/messages",
  editProjectMessage: "/api/projects/:projectId/discussion/messages/:messageId",
  deleteProjectMessage:
    "/api/projects/:projectId/discussion/messages/:messageId",
  pinProjectMessage:
    "/api/projects/:projectId/discussion/messages/:messageId/pin",
  getDiscussionSocketToken: "/api/discussion-socket/connect/:projectId",
  /*************************** Practice Projects API ******************************/
  practiceProjectsStats: "/api/practice-projects/stats",
  getPracticeProjects: "/api/practice-projects",
  createPracticeProject: "/api/practice-projects",
  updatePracticeProject: "/api/practice-projects",
  deletePracticeProject: "/api/practice-projects",
  publishPracticeProject: "/api/practice-projects",
  enrollPracticeProject: "/api/practice-projects",
  updatePracticeProjectProgress: "/api/practice-projects",
  updatePracticeProjectAccess: "/api/practice-projects",
  myPracticeProjectEnrollments: "/api/practice-projects/my-enrollments",
  practiceProjectsQA: "/api/practice-projects",
  /*************************** AI Service API ******************************/
  aiGenerateScript: "/api/v1/generate-script/:projectId",
  aiGetFeedback: "/api/v1/feedback/:projectId/:studentId",
  aiChatStatus: "/api/v1/health",
  /*************************** AI Chatbot WS ******************************/
  aiChatWS: "/api/v1/chat/:projectId/:studentId",
  aiChatSessions: "/api/v1/chat/sessions/:projectId/:studentId",
  aiChatHistory: "/api/v1/chat/history/:sessionId",
  /*************************** Session API ******************************/
  sessionWorkspaceUrl: "/api/session/workspace-url",
  workspaceLaunchPayload: "/api/session/workspace-launch-payload/:projectId",
  sessionAgentToken: "/api/session/agent-token",
  /*************************** Fishbone Chatbot API ******************************/
  fishboneCreateConversation: "/api/chat/conversations",
  fishboneSendMessage: "/api/chat/message",
  fishboneGetMessages: "/api/chat/conversations/:conversationId/messages",
  /*************************** Agent API ******************************/
  agentWake: "/api/agent/wake",
  agentSleep: "/api/agent/sleep",
  agentSessionStatus: "/api/agent/session-status/:projectId",
} as const;

export type ApiName = keyof typeof APIMapping;
// Note: readEnv was unused and caused TS noUnusedLocals error; keeping logic commented for future use.
// function readEnv() {
//   // CRA / Next.js
//   if (typeof process !== "undefined" && typeof process.env !== "undefined") {
//     return process.env as Record<string, string | undefined>;
//   }
//   // Vite
//   if (typeof import.meta !== "undefined" && (import.meta as any).env) {
//     return (import.meta as any).env as Record<string, string | undefined>;
//   }
//   // Runtime-injected env (optional)
//   if (typeof window !== "undefined" && (window as any).__ENV__) {
//     return (window as any).__ENV__;
//   }
//   return {};
// }

const getBITSEndApiMap = (name: ApiName) => {
  try {
    // ensure no duplicate slash
    return `${BASE_URL.replace(/\/$/, "")}${APIMapping[name]}`;
  } catch (error) {
    console.error("Error in getBITSEndApiMap:", error);
    throw error;
  }
};

export const getAIEndApiMap = (name: ApiName) => {
  try {
    return `${AI_BASE_URL.replace(/\/$/, "")}${APIMapping[name]}`;
  } catch (error) {
    console.error("Error in getAIEndApiMap:", error);
    throw error;
  }
};

export const getAIWSEndApiMap = (name: ApiName) => {
  try {
    return `${AI_WS_URL.replace(/\/$/, "")}${APIMapping[name]}`;
  } catch (error) {
    console.error("Error in getAIWSEndApiMap:", error);
    throw error;
  }
};

export default getBITSEndApiMap;
